import React from 'react';

import IDatatableEntry from 'common/types/IDatatableEntry';

import FormatterIndex from './formattersIndex';

const Formatters = ({ entry, formatter, action }: IDatatableEntry) => {
  const Component = FormatterIndex[formatter];

  return <Component entry={entry} action={action} />;

};

export default Formatters;